import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {ImageresizeApi, Raven} from 'modules';
import {BannerAd, Loader} from 'components';
import {validateProcessResponse} from 'utils';

import BulkImageSelect from 'containers/BulkResize/BulkImageSelect';
import BulkImageAdjust from 'containers/BulkResize/BulkImageAdjust';
import BulkImageDownload from 'containers/BulkResize/BulkImageDownload';

export default class BulkResize extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: 'select',
      bulkImages: []
    };
  }

  removeImage = (id) => this.setState(({ bulkImages }) => ({
    bulkImages: bulkImages.filter((image) => image.imageId !== id)
  }));

  resizeImages = (images) => {
    let convertedImages;

    // TODO: Get a real progress indicator since this takes a while
    // Maybe this: https://tympanus.net/codrops/2014/04/09/how-to-create-a-circular-progress-button/
    this.setState({
      step: 'loading'
    });

    ImageresizeApi.editImages(images)
      .then(validateProcessResponse)
      .then(({ results }) => {
        convertedImages = results.map((result, idx) => ({
          originalImage: this.state.bulkImages[idx],
          imageType: images[idx].imageType,
          ...result
        }));

        return ImageresizeApi.createArchive(convertedImages, 'Images');
      })
      .then(validateProcessResponse)
      .then(({ results }) => this.setState({
        step: 'download',
        result: results[0],
        convertedImages
      }))
      .catch((error) => this.setState({
        step: 'error',
        error
      }));
  };

  handleImagesUploaded = (bulkImages) => this.setState({
    step: 'adjust',
    bulkImages
  });

  handleUploadErrors = (errors) => {
    this.setState({
      step: 'error',
      error: new Error(errors[0])
    })
    
    Raven.clog(errors[0], "BulkResize");
  };
  renderError() {
    const {error} = this.state;

    return (
      <div className='error'>
        <p>The image could not be resized:</p>
        <p className='errorMessage'>{error.message}</p>
      </div>
    );
  }

  renderStep() {
    const {step, bulkImages, convertedImages, result} = this.state;

    switch (step) {
      case 'select':
        return (
          <BulkImageSelect
            onDone={this.handleImagesUploaded}
            onErrors={this.handleUploadErrors}
          />
        );
      case 'adjust':
        return (
          <BulkImageAdjust
            bulkImages={bulkImages}
            removeImage={this.removeImage}
            resizeImages={this.resizeImages}
          />
        );
      case 'download':
        return (
          <BulkImageDownload
            result={result}
            convertedImages={convertedImages}
          />
        );
      case 'error':
        return this.renderError();
      case 'loading':
        return <Loader />;
      default:
        return null;
    }
  }

  render() {
    const shareUrl = ImageresizeApi.BASE_URL + '/bulk-resize';
    const title = 'Bulk image resize tool | ImageResize.org';
    const desc = 'Use Bulk Resize tool to resize, compress, or convert multiple images online for free. You can also specify the image size you want in KB or MB.';
    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content={desc}
          />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={desc} />
          <meta property="og:image" content="/social.png" />
        </Helmet>
        <BannerAd />
        {this.renderStep()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BulkResize/index.jsx